import { render, staticRenderFns } from "./posChannelModal.vue?vue&type=template&id=69f02b7d&"
import script from "./posChannelModal.vue?vue&type=script&lang=js&"
export * from "./posChannelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports